import IPresetOutput from "@/api/models/IPresetOutput";

export default (preset: IPresetOutput) => {
  const d = new FormData();
  d.append("id", preset.id);
  d.append("name", preset.name);
  d.append("companyType", preset.companyType);
  d.append("clientId", preset.clientId);
  d.append("vendorId", preset.vendorId);
  d.append("staffId", preset.staffId);
  d.append("expenseCategoryId", preset.expenseCategoryId);
  d.append("constructionTypeId", preset.constructionTypeId);
  return d;
};
